import React from 'react';

import { AccordionItem } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';
import WithLib from '@UI/hoc/WithLib';

export default WithLib(['collapsible', 'toggable'])(UI(AccordionItem)());
